// ─── Token Storage ────────────────────────────────────────────────────────────
// Single source of truth for JWT token persistence.
// All token reads/writes go through this module — never use localStorage directly.

const ACCESS_KEY = 'cmms-access-token'
const REFRESH_KEY = 'cmms-refresh-token'

export const tokenStorage = {
  getAccessToken(): string | null {
    try {
      return localStorage.getItem(ACCESS_KEY)
    } catch {
      return null
    }
  },

  getRefreshToken(): string | null {
    try {
      return localStorage.getItem(REFRESH_KEY)
    } catch {
      return null
    }
  },

  setTokens(access: string, refresh: string): void {
    try {
      localStorage.setItem(ACCESS_KEY, access)
      localStorage.setItem(REFRESH_KEY, refresh)
    } catch {
      // Storage unavailable — fail silently
    }
  },

  setAccessToken(access: string): void {
    try {
      localStorage.setItem(ACCESS_KEY, access)
    } catch {
      // ignore
    }
  },

  clearTokens(): void {
    try {
      localStorage.removeItem(ACCESS_KEY)
      localStorage.removeItem(REFRESH_KEY)
    } catch {
      // ignore
    }
  },

  hasTokens(): boolean {
    return !!this.getAccessToken()
  },
}
